import DynamoDB from 'aws-sdk/clients/dynamodb';


export const getDynamoDBClient = credentials => new DynamoDB.DocumentClient({
  apiVersion: '2012-08-10',
  region: 'us-west-2',
  sslEnabled: true,
  credentials: credentials,
});

export const getUnitReleasedJobs = async (ddb, locator) => {
  let items = [], startKey = null;
  while(true) {
    const { Items, LastEvaluatedKey } = await ddb.query({
      TableName: 'Jobs',
      IndexName: 'jobStatus-jobLocator-index',
      KeyConditionExpression: 'jobStatus = :jobStatus AND jobLocator = :jobLocator',
      ExpressionAttributeValues: {
        ':jobStatus': 'Released',
        ':jobLocator': locator,
      },
      ExclusiveStartKey: startKey,
    }).promise();
    items.push(...Items);
    if(LastEvaluatedKey) startKey = LastEvaluatedKey;
    else break;
  }
  return items;
};

export const getToolsWithRequiredOperators = async (ddb, locator) => {
  let items = [], startKey = null;
  const toolUnit = locator.split('-').pop();
  while(true) {
    const { Items, LastEvaluatedKey } = await ddb.query({
      TableName: 'ToolData',
      IndexName: 'toolUnit-requiredOperators-index',
      KeyConditionExpression: 'toolUnit = :toolUnit',
      ExpressionAttributeValues: { ':toolUnit': toolUnit },
      ExclusiveStartKey: startKey,
    }).promise();
    items.push(...Items);
    if(LastEvaluatedKey) startKey = LastEvaluatedKey;
    else break;
  }
  return items;
};

export const getToolsWithPmDates = async (ddb, unit) => {
  let items = [], startKey = null;
  while(true) {
    const { Items, LastEvaluatedKey } = await ddb.query({
      TableName: 'ToolData',
      IndexName: 'toolUnit-lastPmDate-index',
      KeyConditionExpression: 'toolUnit = :toolUnit',
      ExpressionAttributeValues: { ':toolUnit': unit },
      ProjectionExpression: 'toolNumber,lastPmDate,pmCycle,cycleCount,eamLocation',
      ExclusiveStartKey: startKey,
    }).promise();
    items.push(...Items);
    if(LastEvaluatedKey) startKey = LastEvaluatedKey;
    else break;
  }
  return items;
};

export const getLocationStandards = async (ddb, locationId) => {
  const { Item } = await ddb.get({
    TableName: 'LocationStandards',
    Key: { locationId },
  }).promise();
  return Item;
};

export const getUnitScheduleRows = async (ddb, locator) => {
  let items = [], startKey = null;
  while(true) {
    const { Items, LastEvaluatedKey } = await ddb.query({
      TableName: 'Scheduling',
      IndexName: 'machineLocator-machineCommonName-index',
      KeyConditionExpression: 'machineLocator = :machineLocator',
      ExpressionAttributeValues: { ':machineLocator': locator },
      ExclusiveStartKey: startKey,
    }).promise();
    items.push(...Items);
    if(LastEvaluatedKey) startKey = LastEvaluatedKey;
    else break;
  }
  return items;
};

export const getMachineScheduleRows = async (ddb, machineSerialNumber) => {
  let items = [], startKey = null;
  while(true) {
    const { Items, LastEvaluatedKey } = await ddb.query({
      TableName: 'Scheduling',
      KeyConditionExpression: 'machineSerialNumber = :machineSerialNumber',
      ExpressionAttributeValues: { ':machineSerialNumber': machineSerialNumber },
      ExclusiveStartKey: startKey,
    }).promise();
    items.push(...Items);
    if(LastEvaluatedKey) startKey = LastEvaluatedKey;
    else break;
  }
  return items;
};

export const getUnitMoldingMachines = async (ddb, locator) => {
  let items = [], startKey = null;
  while(true) {
    const { Items, LastEvaluatedKey } = await ddb.query({
      TableName: 'MachineAttributes',
      IndexName: 'machineLocator-machineCategory-index',
      KeyConditionExpression: 'machineLocator = :machineLocator AND machineCategory = :machineCategory',
      ExpressionAttributeValues: {
        ':machineLocator': locator,
        ':machineCategory': 'MOLDING',
      },
      ExclusiveStartKey: startKey,
    }).promise();
    items.push(...Items);
    if(LastEvaluatedKey) startKey = LastEvaluatedKey;
    else break;
  }
  return items;
};

export const getUnitAssemblyMachines = async (ddb, locator) => {
  let items = [], startKey = null;
  while(true) {
    const { Items, LastEvaluatedKey } = await ddb.query({
      TableName: 'MachineAttributes',
      IndexName: 'machineLocator-machineCategory-index',
      KeyConditionExpression: 'machineLocator = :machineLocator AND machineCategory = :machineCategory',
      ExpressionAttributeValues: {
        ':machineLocator': locator,
        ':machineCategory': 'ASSEMBLY',
      },
      ExclusiveStartKey: startKey,
    }).promise();
    items.push(...Items);
    if(LastEvaluatedKey) startKey = LastEvaluatedKey;
    else break;
  }
  return items;
};

export const putScheduleItem = (ddb, scheduleItem, updateTime, userId) => ddb.transactWrite({
  TransactItems: [
    {
      Put: {
        TableName: 'Scheduling',
        Item: scheduleItem,
      },
    },
    {
      Put: {
        TableName: 'SchedulingUpdates',
        Item: {
          machineSchedulingId: `${scheduleItem.machineSerialNumber}|${scheduleItem.schedulingId}`,
          updateTime,
          userId,
          ...scheduleItem,
        },
      },
    },
  ],
}).promise();

export const deleteScheduleItem = (ddb, machineSerialNumber, schedulingId, updateTime, userId) => ddb.transactWrite({
  TransactItems: [
    {
      Delete: {
        TableName: 'Scheduling',
        Key: { machineSerialNumber, schedulingId },
      },
    },
    {
      Put: {
        TableName: 'SchedulingUpdates',
        Item: {
          machineSchedulingId: `${machineSerialNumber}|${schedulingId}`,
          updateTime,
          userId,
          deleted: true,
        },
      },
    },
  ],
}).promise();